import React from "react";
import { Shield, Clock, Award, Globe, Heart, TrendingUp } from "lucide-react";
import BenefitCard from "./benefits/BenefitCard";
import BenefitsHeader from "./benefits/BenefitsHeader";
import TestimonialsSection from "./benefits/TestimonialsSection";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const BenefitsSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.sellCar?.benefitsSection || {};
  const benefitsData = sectionData.benefits || [];

  const icons = [
    <Shield className="w-12 h-12 text-blue-500" />,
    <Clock className="w-12 h-12 text-green-500" />,
    <TrendingUp className="w-12 h-12 text-purple-500" />,
    <Globe className="w-12 h-12 text-orange-500" />,
    <Heart className="w-12 h-12 text-red-500" />,
    <Award className="w-12 h-12 text-yellow-500" />,
  ];
  const bgImages = [
    "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1466442929976-97f336a657be?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1581090464777-f3220bbe1b8b?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1486754735734-325b5831c3ad?auto=format&fit=crop&w=800&q=80",
  ];

  const benefits = benefitsData.map((benefit: any, index: number) => ({
    icon: icons[index] || icons[0],
    title: benefit.title || "",
    description: benefit.description || "",
    bgImage: bgImages[index] || bgImages[0],
  }));

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <BenefitsHeader />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <BenefitCard key={index} benefit={benefit} index={index} />
          ))}
        </div>

        <TestimonialsSection />
      </div>
    </section>
  );
};

export default BenefitsSection;
